var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttenderRank1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "attender_rank_1_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 22,
    width: 179,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.671 22H11v154h178.671V22z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#attender_rank_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.601 26.197c-4.284-5.8-13.022-5.539-16.998.477C19.228 42.39 19.163 63.531 31 79.566c14.77 20.011 42.629 24.7 63.092 10.974L46.6 26.197z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.32 60.065c-6.668-2.746-14.011 2.001-14.286 9.201-.72 18.808 10.192 36.923 28.637 44.522 23.018 9.475 49.278-.922 59.66-23.248L61.51 74.962 25.326 60.065h-.006z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.381 26.197c4.284-5.8 13.022-5.539 16.998.477 10.376 15.715 10.441 36.857-1.395 52.892-14.771 20.011-42.629 24.7-63.092 10.974l47.489-64.343z",
    fill: "#338993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.353 60.065c6.675-2.746 14.011 2.001 14.286 9.201.72 18.808-10.192 36.923-28.638 44.522-23.017 9.475-49.277-.922-59.659-23.248l37.821-15.578 36.183-14.897h.007z",
    fill: "#197B85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.717 28.813h100.808c6.026 0 10.919 4.884 10.919 10.9v75.062c0 33.79-27.478 61.223-61.323 61.223s-61.323-27.433-61.323-61.223V39.714c0-6.017 4.893-10.901 10.92-10.901z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.999 54.304h70.244c4.199 0 7.605 3.4 7.605 7.592v45.947c0 23.542-19.146 42.664-42.733 42.664-23.581 0-42.734-19.115-42.734-42.664v-45.94c0-4.192 3.406-7.593 7.605-7.593l.013-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25 56.92a4.988 4.988 0 014.985 4.976v45.947c0 22.084-17.994 40.049-40.114 40.049-22.12 0-40.114-17.965-40.114-40.049v-45.94c0-2.747 2.24-4.977 4.985-4.977h70.245m0-2.616H66.992c-4.199 0-7.605 3.401-7.605 7.593v45.947c0 23.562 19.133 42.664 42.734 42.664 23.601 0 42.734-19.102 42.734-42.664V61.903c0-4.192-3.406-7.593-7.605-7.593h-.013z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.215 28.813l-32.41 32.364v48.026l80.515-80.39H73.215zM97.287 95.934l63.472-63.368a10.902 10.902 0 00-8.234-3.754h-15.268L83.656 82.327l13.631 13.609z",
    fill: "#fff",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttenderRank1);
export default ForwardRef;